// extracted by mini-css-extract-plugin
export default {"ImageCarousel":"ImageCarousel_ImageCarousel__z-ad-","image":"ImageCarousel_image__Ayf51","link":"ImageCarousel_link__DtTCp","video":"ImageCarousel_video__6ljFd"};